import React from 'react';
import { Layer, Line } from 'react-konva';
import { useApp } from 'stateMgmt/AppContext';

export function GridLayer({ scale = 100, position = { x: 0, y: 0 }, stageWidth, stageHeight }) {
  const { ui: {gridSize} } =  useApp();
  
  
  // Calculate visible grid range in meters
  // Stage position is in screen pixels, scale converts pixels to meters
  // To get world coordinates: (screenCoord - stagePosition) / stageScale
  const worldStartX = -position.x / scale;
  const worldEndX = (stageWidth - position.x) / scale;
  const worldStartY = -position.y / scale;
  const worldEndY = (stageHeight - position.y) / scale;
  
  // Round to grid boundaries
  const startX = Math.floor(worldStartX / gridSize) * gridSize;
  const endX = Math.ceil(worldEndX / gridSize) * gridSize;
  const startY = Math.floor(worldStartY / gridSize) * gridSize;
  const endY = Math.ceil(worldEndY / gridSize) * gridSize;

  const lines = [];
  
  // Vertical lines (coordinates in meters)
  for (let x = startX; x <= endX; x += gridSize) {
    lines.push(
      <Line
        key={`v-${x}`}
        points={[x, startY, x, endY]}
        stroke="#666666"
        strokeWidth={0.1} 
        strokeScaleEnabled={false}
        listening={false}
      />
    );
  }
  
  // Horizontal lines (coordinates in meters)
  for (let y = startY; y <= endY; y += gridSize) {
    lines.push(
      <Line
        key={`h-${y}`}
        points={[startX, y, endX, y]}
        stroke="#666666"
        strokeWidth={0.1} 
        strokeScaleEnabled={false}
        listening={false}
      />
    );
  }

  return (
    <Layer listening={false}>
      {lines}
    </Layer>
  );
}
